import React from "react";
import { useQuery } from "react-query";

import Loading from "src/components/Loading";
import { getSection } from "src/hooks/useContentful/getSection";
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";

import contentfulClient from "src/services/contentful";
import useMedia from "use-media";
import Carroussel from "./Carroussel";
import Item from "./Item";
import { ContainerListButton, InnerContainer } from "./styles";

function Steps() {
	const isMd = useMedia({ minWidth: 1024 });
	const content = useFetchContent();
	const section = getSection({
		sectionName: "landingStepperSection",
		data: content.data,
	});

	const { data, isLoading } = useQuery(
		"getSteps",
		() =>
			Promise.all(
				section.steps.map(
					async (step) => await contentfulClient.getEntry(step.sys.id)
				)
			),
		{
			enabled: content.data && !content.isLoading,
		}
	);

	if (content.isLoading || !content.data || isLoading || !data)
		return <Loading />;

	const newData = () => {
		return 	[
			{
				 "fields":{
						"title":"Faça seu cadastro",
						"description":"O cadastro garante sua identificação como cliente Bradesco, além da comunicação entre você e a Veloe.",
						"image":{
							 "fields":{
									"file":{
										 "url": '/bradescoclassic/assets/icon_tool.svg',
									}
							 }
						},
				 }
			},
			{
				 "fields":{
						"title":"Ative a tag",
						"description":"Ao receber a tag,  acesse o aplicativo ou o site Veloe, e entenda como <a href='https://minha.veloe.com.br/conta/login?_ga=2.11870196.1734958778.1599654009-999822674.1592510767' target='_blank'>ativar o serviço</a>",
						"image":{
							 "fields":{
									"file":{
										 "url":'/bradescoclassic/assets/icon_v.svg',
									}
							 }
						},
				 }
			},
			{
				 "fields":{
						"title":"Instale a tag",
						"description":"Depois da ativação, acesse o aplicativo ou o site Veloe, e <a href='https://veloe.com.br/adesivo/' target='_blank'>aprenda a instalar</a> a tag em seu veículo.",
						"image":{
							 "fields":{
									"file":{
										 "url":'/bradescoclassic/assets/icon_car.svg',
									}
							 }
						},
				 }
			}
	 ]
		}

	const list = data.map(({ fields }, index) => (
		<Item item={fields} key={index} />
	));

	return (
		<InnerContainer>
				{isMd ? (
					<ContainerListButton>
						{data.map(({ fields }, index) => (
								<Item key={index} item={fields} index={index} />
							))}
					</ContainerListButton>
					) : (
						<Carroussel list={list} />
					)}
		</InnerContainer>
	);
}

export default Steps;